module.exports = __webpack_public_path__ + "static/media/logo-colorida.7bd47d64.svg";